export const getCountryFlag = (country: string) => {
    if (country === 'Australia') return '/au_flag.png';
    else if (country === 'Canada') return '/ca_flag.png';
    else if (country === 'United Kingdom') return '/uk_flag.png';
    else if (country === 'France') return '/fr_flag.png';
    else if (country === 'Spain') return '/sp_flag.png';
};

export const getCountryFlagBig = (country: string) => {
    if (country === 'Australia') return '/au_visa_img.png';
    else if (country === 'Canada') return '/ca_visa_img.png';
};

export const getCountryVisaCardFlag = (country: string) => {
    if (country === 'Australia') return '/au_visa_card.png';
    else if (country === 'Canada') return '/ca_visa_card.png';
};

export const getLanguageFlag = (language: string) => {
    if (language === 'English') return '/ca_visa_card.png';
    else if (language === 'French') return '/ca_visa_card.png';
};
